import React from 'react';
import { Box, Typography, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import './migration-notice.scss';

const REDIRECT_URL = 'https://infoprolearning.oneguru.ai/';

export const MigrationNotice: React.FC = () => {
	const handleRedirect = () => {
		window.open(REDIRECT_URL, '_blank', 'noopener,noreferrer');
	};

	return (
		<Box className='migration-notice-area'>
			<Box className='migration-notice-wrapper'>
				<Box className='migration-notice-inner'>
					<Typography variant='h4' className='migration-notice-title'>
						Migration Notice
					</Typography>
					<Box className='migration-notice-content'>
						<Typography className='migration-notice-text'>
							The functionality previously available on this page has now been migrated to <strong>OneGuru</strong>.
							To continue using this feature, please access it through the OneGuru application using the link below:
						</Typography>
						<Button
							className='migration-notice-btn'
							onClick={handleRedirect}
							variant='contained'
							color='primary'
						>
							Go to OneGuru
						</Button>
						<Box className='migration-notice-details'>
							<Typography className='migration-notice-subhead'>Please note:</Typography>
							<ul className='migration-notice-list'>
								<li>This page is no longer active in Unlock:U</li>
								<li>All future updates and actions should be performed in OneGuru</li>
								<li>
									Your existing data has been migrated and synced to the new platform
								</li>
							</ul>
						</Box>
						{/* <Typography className='migration-notice-text'>
							We expect normal access to resume by <strong>May 25</strong> through the{' '}
							<strong>OneGuru</strong> application. A follow-up communication will be shared once the
							system is back online.
						</Typography> */}
						<Typography className='migration-notice-thanks'>
							Thank you for your cooperation and support during this transition.
						</Typography>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};
